export const BENEFICIARY_FIELDS = new Set([
  'account_number','account_no','ifsc_code','ifsc','beneficiary_name','bene_name',
  'customer_mobile','mobile_number','upi_id','vpa','acc_no',
  'beneficiary_account_number','beneficiary_ifsc_code',
  'beneficiary_phone','beneficiary_type','bank_name','bank_code',
  'remitter_full_name','remitter_phone','remitter_mobile_number','remitter_mobile',
  'beneficiary_mobile_number','beneficiary_mobile',
  'verification_status','is_active',
]);

export const MERCHANT_FIELDS = new Set([
  'mid','merchant_id','merchant_type','payout_company','txncategory','txn_category',
  'bid','business_id','merchant_name','merchant_mobile','merchant_account_no','merchant_account_number',
]);

export const IDENTIFIER_FIELDS = new Set([
  'merchant_ref_id','txn_id','request_id','utr','rrn','bank_ref_id','ref_id',
  'order_id','partner_txn_id','auto_id','batch_txn_id','external_txn_id',
  'beneficiary_id','payment_ref_id','wallet_txn_id','sub_provider',
  // AEPS identifiers
  'ipay_id','ipay_uuid','external_ref_no_key',
]);

export const SYSTEM_FIELDS = new Set([
  'id','created_at','updated_at','version','redirect_url','api_name',
  'txnCategory','txn_category','meta','provider_response',
  'txn_amount','amount','net_amount','txn_status','status',
  'payment_mode','merchant_commission','merchant_commission_amount',
  'company_commission','company_commission_amount',
  'sender','receiver','commissions','refund','verification_charge',
  'walletLedger','walletledgerfound','response_body',
  'debit','credit',
]);

export const PAYOUT_CATEGORIES   = new Set(['DMT','BZCOUT','REMITA','DMT_ADD_CUS','SETTLEMENT']);
export const RECHARGE_CATEGORIES = new Set(['RECHARGE','CCBP']);
export const AEPS_CATEGORIES     = new Set(['AEPS']);
export const PG_CATEGORIES       = new Set(['PGW','UPI','FINKEDA']);

export const STATUS_MAP = {
  success:  { bg: '#ecfdf5', color: '#059669', border: '#a7f3d0', dot: '#10b981', label: 'Success'  },
  failed:   { bg: '#fef2f2', color: '#dc2626', border: '#fecaca', dot: '#ef4444', label: 'Failed'   },
  pending:  { bg: '#fffbeb', color: '#d97706', border: '#fde68a', dot: '#f59e0b', label: 'Pending'  },
  refunded: { bg: '#f5f3ff', color: '#7c3aed', border: '#ddd6fe', dot: '#8b5cf6', label: 'Refunded' },
  default:  { bg: '#f8fafc', color: '#64748b', border: '#e2e8f0', dot: '#94a3b8', label: ''         },
};
